import { TopToolbarIconBotton } from '../navigation/navigation-data';
import { defaults } from 'lodash';
import { EventEmitter } from '@angular/core';
import { Nullable, Optional } from '../shared.types';

export interface PageConfiguration {
  showMobileBottomNavbar?: Optional<boolean>;
  showMobilePageTitle?: Optional<boolean>;
  hideDesktopNavigationMenu?: Optional<boolean>;
  hideDesktopAccountMenu?: Optional<boolean>;

  topLeftToolbarIconButton?: Optional<TopToolbarIconBotton>;
  topRightToolbarIconButton?: Optional<TopToolbarIconBotton>;
  /**
   * set to true to hide the margins of the page content container
   */
  useAppFullWidth?: Optional<boolean>;

  useDesktopAppFullWidth?: Optional<boolean>;

  /**
   * a list of classes separated with spaces to be appended to <body> tag when this page is loaded.
   */
  bodyClasses?: Optional<string>;

  hideHeaderToolbar?: Optional<boolean>;
}

export function AppPage(pageConfiguration: PageConfiguration) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  return function(constructor: Function) {
    let parent = Object.getPrototypeOf(constructor);
    parent = parent ? parent.prototype : null;
    const parentConfig = parent ? parent['pageConfiguration'] : {};
    constructor.prototype['pageConfiguration'] = defaults(
      pageConfiguration,
      parentConfig,
    );
  };
}

export function getAppPageConfiguration(clazz: any): Nullable<PageConfiguration> {
  if (clazz && clazz.prototype && clazz.prototype['pageConfiguration']) {
    return clazz.prototype['pageConfiguration'];
  }
  return null;
}

export abstract class AppPageComponent {
  readonly pageConfigurationChanges: EventEmitter<PageConfiguration> =
    new EventEmitter<PageConfiguration>();

  abstract executeAction(actionName: string, state?: any, event?: any): void;
}
